import { useReducer, useCallback } from 'react';
import { IRequestType } from '../../../constants/interfaces';

interface DialogState {
  handbookChecked: boolean;
  handbookOpen: boolean;
  pendingRequestType: IRequestType | null;
}

type DialogAction =
  | { type: 'OPEN_HANDBOOK'; payload: IRequestType }
  | { type: 'CLOSE_HANDBOOK' }
  | { type: 'CHECK_HANDBOOK'; payload: boolean };

// Reducer function for dialog state
function dialogReducer(state: DialogState, action: DialogAction): DialogState {
  switch (action.type) {
    case 'OPEN_HANDBOOK':
      return {
        ...state,
        handbookChecked: false,
        handbookOpen: true,
        pendingRequestType: action.payload,
      };
    case 'CLOSE_HANDBOOK':
      return { ...state, handbookOpen: false, pendingRequestType: null };
    case 'CHECK_HANDBOOK':
      return { ...state, handbookChecked: action.payload };
    default:
      return state;
  }
}

export function useHandbookDialog() {
  const [dialogState, dispatch] = useReducer(dialogReducer, {
    handbookChecked: false,
    handbookOpen: false,
    pendingRequestType: null,
  });

  const openHandbook = useCallback((type: IRequestType) => {
    dispatch({ payload: type, type: 'OPEN_HANDBOOK' });
  }, []);

  const closeHandbook = useCallback(() => {
    dispatch({ type: 'CLOSE_HANDBOOK' });
  }, []);

  const setHandbookChecked = useCallback((checked: boolean) => {
    dispatch({ payload: checked, type: 'CHECK_HANDBOOK' });
  }, []);

  const showHandbookDialog =
    dialogState.handbookOpen &&
    !!dialogState.pendingRequestType?.handbook_content;

  return {
    closeHandbook,
    dialogState,
    openHandbook,
    setHandbookChecked,
    showHandbookDialog,
  };
}
